import React, { memo, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import useProductCategory from "../../hooks/useProductCategory";

const SampleNextArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button" onClick={onClick}
            className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
        >
            <i className="ph ph-caret-right" />
        </button>
    );
});

const SamplePrevArrow = memo((props) => {
    const { className, onClick } = props;
    return (
        <button
            type="button"
            onClick={onClick}
            className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
            style={{ zIndex: 1 }}
       >
            <i className="ph ph-caret-left" />
        </button>
    );
});

const CategoryListHome = () => {
    const {
        fetchProductCategory,
        data: productCategory,
        status: productCategoryStatus,
        error: productCategoryError,
    } = useProductCategory();
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === 'undefined') return false;
        return window.innerWidth <= 575;
    });

    useEffect(() => {
        fetchProductCategory();

    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 575);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const chunk = (arr, size) => {
        const out = [];
        for (let i = 0; i < arr.length; i += size) {
            out.push(arr.slice(i, i + size));
        }
        return out;
    };


    const StaticProductCategory = [


        {
            id: "",
            image: "assets/images/brand_temp/woman apparel.png",
            imageData: { url: "assets/images/brand_temp/woman apparel.png" },
            isActive: true,
            name: "Woman's Apparel"
        },
        {
            id: "",
            image: "assets/images/brand_temp/man apparel.png",
            imageData: { url: "assets/images/brand_temp/man apparel.png" },
            isActive: true,
            name: "Man's Apparel"
        },
        {
            id: "",
            image: "assets/images/brand_temp/woman bag and shoes.png",
            imageData: { url: "assets/images/brand_temp/woman bag and shoes.png" },
            isActive: true,
            name: "Woman's Bags, Shoes"
        },
        {
            id: "",
            image: "assets/images/brand_temp/mans bag and shoes.png",
            imageData: { url: "assets/images/brand_temp/mans bag and shoes.png" },
            isActive: true,
            name: "Man's Bags , Shoes"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Accessories & Jeweleries.png",
            imageData: { url: "assets/images/brand_temp/Accessories & Jeweleries.png" },
            isActive: true,
            name: "⁠Accessories & Jeweleries"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Watches.png",
            imageData: { url: "assets/images/brand_temp/Watches.png" },
            isActive: true,
            name: "Watches"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Mobile & Gadgets.png",
            imageData: { url: "assets/images/brand_temp/Mobile & Gadgets.png" },
            isActive: true,
            name: "Mobile & Gadgets"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Computers & Electronics.png",
            imageData: { url: "assets/images/brand_temp/Computers & Electronics.png" },
            isActive: true,
            name: "Computers & Electronics"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Home Appliances.png",
            imageData: { url: "assets/images/brand_temp/Home Appliances.png" },
            isActive: true,
            name: "Home Appliances"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Home & Living.png",
            imageData: { url: "assets/images/brand_temp/Home & Living.png" },
            isActive: true,
            name: "Home & Living"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Hobbies.png",
            imageData: { url: "assets/images/brand_temp/Hobbies.png" },
            isActive: true,
            name: "Hobbies"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Sports & Outdoor.png",
            imageData: { url: "assets/images/brand_temp/Sports & Outdoor.png" },
            isActive: true,
            name: "⁠Sports & Outdoor"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Beauty & Personal Care.png",
            imageData: { url: "assets/images/brand_temp/Beauty & Personal Care.png" },
            isActive: true,
            name: "Beauty & Personal Care"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Health & Wealth.png",
            imageData: { url: "assets/images/brand_temp/Health & Wealth.png" },
            isActive: true,
            name: "⁠Health & Wealth"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Packaging & Printing.png",
            imageData: { url: "assets/images/brand_temp/Packaging & Printing.png" },
            isActive: true,
            name: "Packaging & Printing"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Kids Apparel.png",
            imageData: { url: "assets/images/brand_temp/Kids Apparel.png" },
            isActive: true,
            name: "⁠Kids Apparel"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Toys & Babies.png",
            imageData: { url: "assets/images/brand_temp/Toys & Babies.png" },
            isActive: true,
            name: "Toys & Babies"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Pets Supplies.png",
            imageData: { url: "assets/images/brand_temp/Pets Supplies.png" },
            isActive: true,
            name: "Pets Supplies"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Auto Parts & Automotive.png",
            imageData: { url: "assets/images/brand_temp/Auto Parts & Automotive.png" },
            isActive: true,
            name: "⁠Auto Parts & Automotive"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Dining & Stay.png",
            imageData: { url: "assets/images/brand_temp/Dining & Stay.png" },
            isActive: true,
            name: "Dining & Stay"
        },
        {
            id: "",
            image: "assets/images/brand_temp/⁠Luggage & Travel.png",
            imageData: { url: "assets/images/brand_temp/Luggage & Travel.png" },
            isActive: true,
            name: "⁠Luggage & Travel"
        },
        {
            id: "",
            image: "assets/images/brand_temp/_Food & Beverages Supplies.png",
            imageData: { url: "assets/images/brand_temp/_Food & Beverages Supplies.png" },
            isActive: true,
            name: "Food & Beverages Supplies"
        },
        {
            id: "",
            image: "assets/images/brand_temp/_Services.png",
            imageData: { url: "assets/images/brand_temp/_Services.png" },
            isActive: true,
            name: "Services"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Miscellaneous.png",
            imageData: { url: "assets/images/brand_temp/Miscellaneous.png" },
            isActive: true,
            name: "Miscellaneous"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Construction & Building.png",
            imageData: { url: "assets/images/brand_temp/Construction & Building.png" },
            isActive: true,
            name: "Construction & Building"
        },
        {
            id: "",
            image: "assets/images/brand_temp/_Machinery.png",
            imageData: { url: "assets/images/brand_temp/_Machinery.png" },
            isActive: true,
            name: "Machinery"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Real Estate & Building.png",
            imageData: { url: "assets/images/brand_temp/Real Estate & Building.png" },
            isActive: true,
            name: "Real Estate & Building"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Lights & Electrical.png",
            imageData: { url: "assets/images/brand_temp/Lights & Electrical.png" },
            isActive: true,
            name: "Lights & Electrical"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Furniture.png",
            imageData: { url: "assets/images/brand_temp/Furniture.png" },
            isActive: true,
            name: "Furniture"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Tools & Hardware.png",
            imageData: { url: "assets/images/brand_temp/Tools & Hardware.png" },
            isActive: true,
            name: "Tools & Hardware"
        },
        {
            id: "",
            image: "assets/images/brand_temp/Agriculture & Raw Material.png",
            imageData: { url: "assets/images/brand_temp/Agriculture & Raw Material.png" },
            isActive: true,
            name: "Agriculture & Raw Material"
        },
    ]


    if (!productCategory || productCategory.length === 0) return null;
    const groupedCategories = chunk(productCategory, isMobile ? 6 : 2);

    const renderCategoryItem = (category, index, mobile = false) => {
        if (!category) return null;

        const mobileItemStyle = mobile
            ? {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                paddingBottom: '6px',
            }
            : {};

        const mobileThumbStyle = mobile
            ? {
                width: '78px',
                height: '78px',
                margin: '0 auto',
            }
            : {};

        const mobileTitleStyle = mobile
            ? {
                fontSize: '12px',
                lineHeight: '1.2',
                minHeight: '2.4em',
                marginBottom: 0,
            }
            : {
                fontSize: '14px',
            };

        return (
            <div
                key={category.id || `${category.name}-${index}`}
                className={`feature-item text-center ${mobile ? '' : index === 0 ? 'mb-30' : 'mb-20'}`}
                style={mobileItemStyle}
            >
                <div className="feature-item__thumb rounded-circle" style={mobileThumbStyle}>
                    <Link to={`/products?category=${encodeURIComponent(category?.slug)}`} className="w-100 h-100 flex-center">
                        <img
                            style={{ maxWidth: "100%" }}
                            src={category?.image + "?width=146" || "assets/images/no-image.png"}
                            alt=""
                        />
                    </Link>
                </div>
                <div className="feature-item__content mt-16">
                    <h6 className="feature-item__title mb-5" style={mobile ? { marginBottom: 0 } : {}}>
                        <Link to={`/products?category=${category.id}`} style={mobileTitleStyle}>
                            {category.name}
                        </Link>
                    </h6>
                </div>
            </div>
        );
    };



    const settings = {
        dots: false,
        arrows: true,
        duplicate: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 8,
        slidesToScroll: 8,
        initialSlide: 0,
        autoplay: false,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                },
            },
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                },
            },

        ],
    };

    return (

        <section className="recommended mt-40">
            <div className="container container-md">
                <div className="feature-item-wrapper">

                    {

                        Array.isArray(productCategory) &&
                        productCategory.length > 0 && (


                            <Slider {...settings}>
                                {
                                    groupedCategories.map((item, index) => (
                                        <div key={index}>
                                            {isMobile ? (
                                                <div
                                                    style={{
                                                        display: 'grid',
                                                        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                                                        gap: '12px 8px',
                                                        paddingBottom: '10px',
                                                    }}
                                                >
                                                    {item.map((category, itemIndex) => renderCategoryItem(category, itemIndex, true))}
                                                </div>
                                            ) : (
                                                <>
                                                    {renderCategoryItem(item[0], 0, false)}
                                                    {renderCategoryItem(item[1], 1, false)}
                                                </>
                                            )}
                                        </div>
                                    ))
                                }
                            </Slider>
                        )
                    }



                </div>
            </div>
        </section>

    )
}

export default CategoryListHome